<template>
  <div class="app_detail_container">
    <PageTitle
      :title="title"
      :showFileBtn="true"
      backPath="AppRemittance"
      :menuArgs="menuArgs"
      @clickFileBtn="clickFileBtn"
    />
    <div class="app_menu_main">
      <div
        v-if="
          String($store.state.userInfo.authority).includes('领导审核') ||
            String($store.state.userInfo.authority).includes('财务审核')
        "
      >
        <RemittancePrint ref="RemittancePrintRef" :printData="form" />
      </div>
      <div v-else>
        <PageDetailDivider ref="PageDetailDividerRef" title="主表信息" />
        <div class="app_menu_main_form">
          <el-form :rules="rules" :model="form">
            <el-form-item label="申请日期" prop="apply_date">
              <el-input placeholder="关联获取" v-date readonly v-model="form.apply_date" />
            </el-form-item>
            <el-form-item label="申请人" prop="users_name">
              <el-input placeholder="关联获取" readonly v-model="form.users_name" />
            </el-form-item>
            <el-form-item label="收款人名称" prop="payee">
              <el-input placeholder="关联获取" readonly v-model="form.payee" />
            </el-form-item>
            <el-form-item label="开户行及账号" prop="bank_account">
              <el-input placeholder="关联获取" readonly v-model="form.bank_account" />
            </el-form-item>
            <el-form-item label="金额" prop="amout">
              <el-input placeholder="关联获取" v-appmoney:2="showMoney" readonly v-model="form.amout" />
            </el-form-item>
            <el-form-item label="大写金额" prop="amout">
              <el-input placeholder="自动计算" readonly :value="convertCurrency(form.amout)" />
            </el-form-item>
            <el-form-item label="汇出日期" prop="remittance_date">
              <el-input placeholder="关联获取" v-date readonly v-model="form.remittance_date" />
            </el-form-item>
            <el-form-item label="汇出公司" prop="remittance_company">
              <el-input placeholder="关联获取" readonly v-model="form.remittance_company" />
            </el-form-item>
            <el-form-item label="汇款事由" prop="subject_matter">
              <el-input type="textarea" :rows="5" placeholder="关联获取" readonly v-model="form.subject_matter" />
            </el-form-item>
            <el-form-item label="备注" prop="memo">
              <el-input type="textarea" :rows="5" placeholder="关联获取" readonly v-model="form.memo" />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <PageDetailBtns ref="PageDetailBtnsRef" menuPath="Remittance" :parentData="this" @handleClick="handleClickBtn" />
    <!-- 附件 -->
    <PageDetailFile ref="PageDetailFileRef" :ID="id" vuePath="Remittance" />
    <!-- 确认dialog -->
    <ConfirmModal ref="ConfirmModalRef" @confirm="sureConfirm" />
  </div>
</template>
<script>
import PageTitle from '@/components/app/PageHeader.vue'
import PageDetailBtns from '@/components/app/PageDetailBtns.vue'
import PageDetailDivider from '@/components/app/PageDetailDivider.vue'
import PageDetailFile from '@/components/app/PageDetailFile.vue'
import ConfirmModal from '@/components/app/ConfirmModal.vue'
import RemittancePrint from '@/components/print/Remittance.vue'

export default {
  components: {
    PageTitle,
    PageDetailBtns,
    PageDetailDivider,
    PageDetailFile,
    ConfirmModal,
    RemittancePrint
  },
  data() {
    return {
      id: -1,
      title: '汇款申请单明细',
      formVisible: false,
      // 表单
      form: {
        id: '',
        users_name: '',
        creator_id: '',
        creator: '',
        createTime: '',
        document_status: 0,
        cmbDocument_status: '',
        apply_date: '',
        users_id: '',
        payee: '',
        bank_account: '',
        amout: '',
        subject_matter: '',
        remittance_company: '',
        remittance_date: '',
        memo: '',
        last_modify_time: ''
      },
      rules: {
        company: [],
        r_date: [],
        r_user: [],
        document_count: [],
        amout: [],
        subject_matter: []
      },
      // 下拉框
      ComBoxItems: {
        company: []
      },
      // 展示金额
      showMoney: true,
      menuArgs: ''
    }
  },
  mounted() {
    this.id = this.$route.query.id

    this.BindText()

    this.menuArgs = this.$route.query.menuArgs
  },
  methods: {
    // 确认
    async sureConfirm(code) {
      if (code === 'refuse') {
        const success = await this.sureObsolete()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      } else if (code === 'leaderReview') {
        const success = await this.sureReview()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      } else if (code === 'unReview') {
        const success = await this.sureUnReview()
        if (success) {
          this.$message.success('取消成功!')

          this.$emit('updateData')
          this.BindText()
        }
      }
    },
    // 拒绝
    refuse() {
      this.$refs.ConfirmModalRef.openDialog('refuse')
    },
    // 领导/总经理审批
    leaderReview() {
      this.$refs.ConfirmModalRef.openDialog('leaderReview')
    },
    // 取消审核
    unReview() {
      this.$refs.ConfirmModalRef.openDialog('unReview')
    },
    // 调用审批接口
    async sureReview(flag = false) {
      const { data: res } = await this.$http.put('/finance/funds_transfers_application/audit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用撤销审核
    async sureUnReview(flag = false) {
      const { data: res } = await this.$http.put('/finance/funds_transfers_application/unaudit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用拒绝接口
    async sureObsolete() {
      const { data: res } = await this.$http.put('/finance/funds_transfers_application/obsolete', [
        {
          id: this.id,
          manager_review: false
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 点击底部按钮
    handleClickBtn(code) {
      switch (code) {
        case 'unReview':
          this.unReview()
          break
        case 'managerReview':
        case 'leaderReview':
          this.leaderReview()
          break
        case 'refuse':
          this.refuse()
          break
      }
    },
    // 绑定数据
    async BindText() {
      const that = this
      const { data: res } = await that.$http.get('/finance/funds_transfers_application', {
        params: {
          id: that.id
        }
      })
      if (res.isSuccess) {
        that.form = res.data
      }

      this.$nextTick(() => {
        if (this.$refs.RemittancePrintRef) {
          this.$refs.RemittancePrintRef.handlePrint()
        }
      })
    },
    // 点击附件按钮
    clickFileBtn() {
      this.$refs.PageDetailFileRef.openDialog()
    },
    showModal() {},
    // 大写金额转换
    convertCurrency(amount) {
      if (amount == null || amount == '') {
        return ''
      }
      return this.amountLtoU(amount)
    },
    // 选择人员
    handleSelect() {},
    // 主表选择框值改变为空时
    clearFormToNull(type) {
      switch (type) {
        case '':
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
@headerHeight: 50px;

.app_detail_container {
  width: 100vw;
  height: 100vh;

  .app_menu_main {
    height: calc(100% - @headerHeight);
    width: 100%;
    // background-color: #fafafa;

    overflow: auto;

    box-sizing: border-box;
    // padding: 0 20px;
    // padding-top: 10px;
    // padding-bottom: 20px;

    /deep/ .el-form-item__label {
      padding: 0 !important;
      font-size: 20px !important;
      font-weight: 500;
      color: #a78897;
    }
    /deep/ .el-input__inner {
      border: 0 !important;
      border-bottom: 1px solid #d1d1d1 !important;
      border-radius: 0;
      padding-left: 0 !important;
      transition: all 0.3s;
      // background-color: #fafafa;
      font-size: 18px !important;
    }

    /deep/ .el-textarea__inner {
      font-size: 18px !important;
    }

    // /deep/ .el-input__inner:hover {
    //   padding-left: 10px !important;
    //   transition: all 0.3s;
    // }
    /deep/ .el-input__inner:focus {
      padding-left: 10px !important;
      transition: all 0.3s;
    }

    .app_menu_main_form {
      box-sizing: border-box;
      padding: 0 20px 20px 20px;
    }
  }
}
.file-list-container {
  // box-sizing: border-box;
  padding: 10px;

  height: 30px;
}
</style>
